import { useCountdown } from '@starsoft/common/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { useRollCompetitions } from '@/api/roll-competitions';
import { RollCompetitionsQueryKeys } from '@/api/roll-competitions/queryKey';

export default function () {
  const queryClient = useQueryClient();
  const { rollCompetition } = useRollCompetitions();

  const { formattedTimeLeft } = useCountdown({
    targetDate: new Date(
      rollCompetition?.cycle?.endAt ?? new Date(),
    ).toString(),
    disabled: !rollCompetition?.cycle,
    onCountdownComplete: () => {
      if (
        !rollCompetition?.cycle ||
        new Date(rollCompetition?.cycle?.endAt) <
          new Date(new Date().getTime() + 10 * 60 * 1000)
      ) {
        return;
      }
      queryClient.invalidateQueries({
        queryKey: [RollCompetitionsQueryKeys.Primary],
      });
    },
  });

  return {
    formattedTimeLeft,
  };
}
